import React from 'react';

export const Aukakronur = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="200"
      height="215"
      viewBox="0 0 200 215"
    >
      <defs>
        <path
          id="path-1"
          d="M0.793793103 0.368694779L118.956724 0.368694779 118.956724 111.645701 0.793793103 111.645701z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-224 -371)">
          <g transform="translate(130 270)">
            <g transform="translate(94 101)">
              <g transform="translate(35.345 .495)">
                <mask id="mask-2" fill="#fff">
                  <use xlinkHref="#path-1"></use>
                </mask>
                <path
                  fill="#163E63"
                  d="M34.11 111.646c3.766-12.412 7.627-25.194 8.274-27.141l16.49-57.027h1.244c5.602 19.01 11.512 38.329 17.115 58.274l7.656 25.894h34.068L82.52.368H38.03C26.319 35.898 13.792 73.061.795 111.646H34.11z"
                  mask="url(#mask-2)"
                ></path>
              </g>
              <path
                fill="#163E63"
                d="M135.865 164.807c5.273 16.813 10.298 33.6 15.601 49.824h36.404l-16.317-49.824h-35.688z"
              ></path>
              <path
                fill="#163E63"
                d="M18.435 164.807a15253.827 15253.827 0 00-16.618 49.824h35.468l15.596-49.824H18.435z"
              ></path>
              <path
                fill="#163E63"
                d="M12.776 129.853c-.188-.738-.443-1.474-.666-2.213h-.07l-.701 2.251c-.847 2.653-2.356 7.079-3.126 9.881h7.657a539.48 539.48 0 00-3.094-9.919zm5.262 16.887c-.403-1.29-.918-2.985-1.33-4.166H7.253c-.333 1.033-.92 2.8-1.29 4.166h2.502v2.802H.001v-2.802h2.06l7.622-22.493h5.042c2.395 7.303 5.046 15.23 7.437 22.493h2.062v2.802h-8.616v-2.802h2.43z"
              ></path>
              <path
                fill="#163E63"
                d="M26.613 144.197v-9.844h-2.575v-2.84h6.514v12.02c0 2.03.256 3.171 2.616 3.171 1.176 0 3.165-.518 4.788-2.027v-10.324h-2.32v-2.84h6.256v15.227h2.54v2.324c-1.36.518-2.724.703-3.57.703-1.806 0-2.616-.555-2.8-2.326-2.17 1.99-4.528 2.508-6.073 2.508-4.564 0-5.377-2.802-5.377-5.752"
              ></path>
              <path
                fill="#163E63"
                d="M56.693 131.547h7.804v2.658h-1.659l-4.822 4.13 5.23 8.557 2.354.327v2.104c-.924.33-2.173.48-2.946.48-.992 0-1.913-.15-2.652-1.366l-4.742-8.001c-.851.702-1.586 1.366-2.394 2.064v4.425h2.279v2.617h-8.686v-2.617h2.503v-20.98H46.2v-2.618h6.666v15.56l5.445-4.682h-1.618v-2.658z"
              ></path>
              <path
                fill="#163E63"
                d="M74.627 141.429c-2.058.15-3.163 1.33-3.163 2.843 0 1.917.882 2.803 2.983 2.803 1.324 0 3.016-.776 4.192-1.883v-4.055l-4.012.292zm7.808 5.35h2.798l.217 2.212c-.993.552-3.126.775-4.122.775-1.435 0-2.429-.333-2.464-2.25-.036 0-.036-.037-.078-.037-2.61 2.357-5.004 2.395-6.072 2.395-4.307 0-5.336-3.095-5.336-5.197 0-2.914 1.986-5.053 6.993-5.384l4.342-.296v-1.069c0-2.692-.846-3.725-3.606-3.725-1.766 0-3.793.37-5.522.959a48.914 48.914 0 01-.736-2.507c2.06-.92 4.822-1.437 7.178-1.437 4.013 0 6.408 1.548 6.408 6.083v9.478z"
              ></path>
              <path
                fill="#163E63"
                d="M97.487 131.547h7.805v2.658h-1.657l-4.825 4.13 5.23 8.557 2.353.327v2.104c-.919.33-2.169.48-2.945.48-.995 0-1.913-.15-2.648-1.366l-4.752-8.001c-.845.702-1.582 1.366-2.39 2.064v4.425h2.28v2.617H87.25v-2.617h2.505v-20.98h-2.76v-2.618h6.663v15.56l5.445-4.682h-1.616v-2.658z"
              ></path>
              <path
                fill="#163E63"
                d="M108.388 131.512l6.26-.036v2.727c.036 0 .108.038.145.038 1.398-1.547 4.196-3.17 7.106-3.17v3.722c-3.018.222-5.78 1.293-7.18 2.14v9.845h2.721v2.764h-9.129v-2.764h2.504v-12.464h-2.427v-2.802z"
              ></path>
              <path
                fill="#163E63"
                d="M131.217 129.853l-1.467-1.366 4.893-6.083 2.357 2.323-5.783 5.126zm.739 4.24c-3.644 0-4.564 3.32-4.564 6.526 0 3.357.663 6.304 4.454 6.304 3.534 0 4.344-3.206 4.344-6.304 0-3.02-.697-6.526-4.234-6.526zm-.368 15.746c-6.071 0-8.245-4.24-8.245-9.22 0-4.94 2.429-9.476 8.54-9.476 6.222 0 8.32 4.537 8.32 9.403 0 4.792-2.174 9.293-8.615 9.293z"
              ></path>
              <path
                fill="#163E63"
                d="M159.878 137.117v9.624h2.723v2.323c-1.028.479-2.648.7-3.642.7-2.91 0-2.983-2.174-2.983-2.914v-8.994c0-2.434-.406-3.578-2.91-3.578-1.512 0-3.493.81-4.858 1.658v13.607h-3.902v-15.228h-2.577v-2.802h6.48v1.585l.182.036c2.064-1.329 4.197-2.026 6.004-2.026 5.19 0 5.483 3.907 5.483 6.009"
              ></path>
              <path
                fill="#163E63"
                d="M165.647 144.197v-9.844h-2.575v-2.84h6.516v12.02c0 2.03.253 3.171 2.613 3.171 1.177 0 3.167-.518 4.788-2.027v-10.324h-2.325v-2.84h6.26v15.227h2.54v2.324c-1.357.518-2.725.703-3.568.703-1.807 0-2.615-.555-2.8-2.326-2.175 1.99-4.526 2.508-6.074 2.508-4.563 0-5.375-2.802-5.375-5.752"
              ></path>
              <path
                fill="#163E63"
                d="M185.685 131.512l6.26-.036v2.727c.036 0 .106.038.144.038 1.4-1.547 4.195-3.17 7.103-3.17v3.722c-3.019.222-5.778 1.293-7.18 2.14v9.845h2.726v2.764h-9.128v-2.764h2.5v-12.464h-2.425v-2.802z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
